import { render, staticRenderFns } from "./RecipeCookingSteps.vue?vue&type=template&id=0cebf6b5&scoped=true"
import script from "./RecipeCookingSteps.vue?vue&type=script&lang=js"
export * from "./RecipeCookingSteps.vue?vue&type=script&lang=js"
import style0 from "./RecipeCookingSteps.vue?vue&type=style&index=0&id=0cebf6b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cebf6b5",
  null
  
)

export default component.exports